import React, { ReactNode } from 'react';
import AntdModal from 'antd/lib/modal';

/**
 * {@docCategory WarningModal}
 */
export interface WarningModalProps {
   /**
    * The title to display.
    */
   title?: ReactNode;

   /**
    * The content.
    */
   content?: ReactNode;

   /**
    * Used to customize the OK button text.
    * @defaultvalue OK
    */
   okText?: ReactNode;

   /**
    * Callback called when the user presses the OK button, presses enter, or hits escape to
    * dismiss the modal.
    */
   onOk?: () => void;
}

export class WarningModal {
   static show(props: WarningModalProps) {
      AntdModal.warning({
                           title: props.title,
                           content: props.content,
                           okText: props.okText,
                           onOk: props.onOk,
                           onCancel: props.onOk
                        });
   }
}
